import TiltedMenuBlock from './TiltedMenuBlock';

export default TiltedMenuBlock;
